import { render, staticRenderFns } from "./Namespace.vue?vue&type=template&id=7428c2c4&scoped=true&"
import script from "./Namespace.vue?vue&type=script&lang=js&"
export * from "./Namespace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7428c2c4",
  null
  
)

export default component.exports